export const MEAL_SUMMARY_WRITING = 'MEAL_SUMMARY_WRITING';
export const MEAL_SUMMARY = 'MEAL_SUMMARY';
export const MEAL_SUMMARY_ERROR = 'MEAL_SUMMARY_ERROR';
export const MEAL_SUMMARY_WRITING_CASH_AND_CHECKS =
  'MEAL_SUMMARY_WRITING_CASH_AND_CHECKS';
export const MEAL_SUMMARY_LOADING_SUMMARY_AMOUNTS =
  'MEAL_SUMMARY_LOADING_SUMMARY_AMOUNTS';
export const MEAL_SUMMARY_AMOUNTS = 'MEAL_SUMMARY_AMOUNTS';
export const MEAL_SUMMARY_UPDATE_OPENING_CASH_CALC =
  'MEAL_SUMMARY_UPDATE_OPENING_CASH_CALC';
export const MEAL_SUMMARY_UPDATE_CLOSING_CASH_CALC =
  'MEAL_SUMMARY_UPDATE_CLOSING_CASH_CALC';
export const MEAL_SUMMARY_GET_USERS = 'MEAL_SUMMARY_GET_USERS';
export const MEAL_SUMMARY_FETCHING_SUMMARY_CHECKS =
  'MEAL_SUMMARY_FETCHING_SUMMARY_CHECKS';
export const MEAL_SUMMARY_OPENING_CHECKS = 'MEAL_SUMMARY_OPENING_CHECKS';
export const MEAL_SUMMARY_CLOSING_CHECKS = 'MEAL_SUMMARY_CLOSING_CHECKS';
export const MEAL_SUMMARY_CLEAR_ERRORS = 'MEAL_SUMMARY_CLEAR_ERRORS';
export const MEAL_SUMMARY_CLEAR_STATE = 'MEAL_SUMMARY_CLEAR_STATE';
export const MEAL_SUMMARY_FETCHING_USER_AND_SUMMARY_AMOUNT =
  'MEAL_SUMMARY_FETCHING_USER_AND_SUMMARY_AMOUNT';



// WEBPACK FOOTER //
// ./src/pages/mealsummary/state/types.js